import { Form, InputGroup } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import styles from "./SearchInput.module.scss";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  size?: "sm" | "lg";
  className?: string;
  fixed?: boolean;
}

const SearchInput = ({
  value,
  onChange,
  placeholder = "Search Documents",
  size = "sm",
  className = "",
  fixed = false,
}: SearchInputProps) => {
  return (
    <InputGroup
      className={`${styles.searchInput} ${className} ${fixed ? styles.fixed : ""}`}
    >
      <InputGroup.Text className={styles.searchIcon}>
        <Search size={20} className="pe-2" />
      </InputGroup.Text>
      <Form.Control
        size={size}
        type="text"
        placeholder={placeholder}
        value={value}
        className="border-start-0 ps-1"
        onChange={(e) => onChange(e.target.value)}
      />
    </InputGroup>
  );
};

export default SearchInput;
